import { render, staticRenderFns } from "./BigDataPlatform.vue?vue&type=template&id=26da9b50&scoped=true&"
import script from "./BigDataPlatform.vue?vue&type=script&lang=js&"
export * from "./BigDataPlatform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26da9b50",
  null
  
)

export default component.exports